exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#error-layout {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n#error-layout > * p {\n  text-align: center;\n}\n#error-layout .container-img {\n  text-align: center;\n}\n#error-layout .container-img p.margin-a {\n  text-align: justify;\n}\n#error-layout .container-img img {\n  margin-top: 3em;\n  width: 50%;\n  max-width: 80vh;\n}", ""]);

// exports
